import apiClient from '@/shared/api/client'

export interface ContractorRow {
  id: string
  contractor_code: string | null
  contractor_name: string
  work_type: string | null
  status: string
  committed_headcount: number | null
  active_total: number
  shortfall_total: number | null
}

export interface DeptStatus {
  department_id: string
  department_name: string
  committed: number
  active: number
  shortfall: number
}

export interface ContractorDetail extends ContractorRow {
  contact_person: string | null
  mobile: string | null
  commission_rule_id?: string | null
  headcount: {
    committed_total: number | null
    active_total: number
    shortfall_total: number | null
    by_department: DeptStatus[]
  }
  workers: { id: string; emp_code: string; emp_name: string;
    department_name: string; is_active: boolean }[]
}

export const contractorApi = {
  list: async (plantId?: string) =>
    (await apiClient.get<ContractorRow[]>('/hr/contractors',
      { params: { plant_id: plantId } })).data,
  detail: async (id: string) =>
    (await apiClient.get<ContractorDetail>(`/hr/contractors/${id}`)).data,
  create: async (body: Record<string, unknown>) =>
    (await apiClient.post<ContractorDetail>('/hr/contractors', body)).data,
  update: async (id: string, patch: Record<string, unknown>) =>
    (await apiClient.patch(`/hr/contractors/${id}`, patch)).data,
  setTargets: async (id: string,
    targets: { department_id: string; committed_count: number }[]) =>
    (await apiClient.put(`/hr/contractors/${id}/department-targets`,
      { targets })).data,
  assign: async (id: string, employeeId: string) =>
    (await apiClient.post(`/hr/contractors/${id}/workers`,
      { employee_id: employeeId })).data,
  unassign: async (id: string, employeeId: string) =>
    (await apiClient.delete(`/hr/contractors/${id}/workers/${employeeId}`)).data,
}
